import React from 'react';

export const CheckListIcon: React.FC = () => (
<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M50 100C77.6142 100 100 77.6143 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6143 22.3858 100 50 100Z" fill="#2A4CA4"/>
<path d="M31.4937 70.0417L21.5833 60.1312L25.4916 56.2229L31.4239 62.1552L43.2885 50.2906L47.1969 54.2687L31.4937 70.0417ZM31.4937 47.7083L21.5833 37.7979L25.4916 33.8896L31.4239 39.8219L43.2885 27.9573L47.1969 31.9354L31.4937 47.7083ZM52.2916 64.4583V58.875H77.4166V64.4583H52.2916ZM52.2916 42.125V36.5417H77.4166V42.125H52.2916Z" fill="white"/>
</svg>

);

